/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unused-state */
import { Typography, withStyles } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MessageType, templateStrings } from "../../../../Constant";
import { fetchSettlementLedgerAction } from "../../../../redux/action-creators/settlementActionCreator";
import { selectedOperator } from "../../../../redux/actions/operatorsAction";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { getSettlementTemplateString } from "../../../../shared/methods/sharedMethods";
import { BarLoader } from "../../../../shared/widgets";
import SettlementModal from "../SettlementModal";
import { setNotificationMessage } from "../../../../redux/actions/notificationAction";

const styles = {
  tableHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  exportBtn: {
    marginRight: "10px",
  },
};

class DayWiseDueList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      selected: [],
      sortBy: "",
      showModal: false,
      rowData: {},
    };
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  handleAction(detail) {
    const {
      operatorId, cityId, location, history,
    } = this.props;
    if (detail?.itemType.toLowerCase() === "operatorpayment") {
      this.setState({ rowData: detail });
      this.showSettlementModal();
    } else {
      const operatorDetails = {
        operatorId,
        cityId,
        operatorName:
          (location.state
            && location.state.operatorName)
          || "12344",
        dueId: detail.dueId,
        date: detail.date,
      };
      history.push(
        "/settlement/operator-settlement/date-details",
        operatorDetails,
      );
    }
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  }

  getList() {
    const { fetchSettlementLedger, cityId, operatorId } = this.props;
    const { pageNo, rowsPerPage } = this.state;
    fetchSettlementLedger({
      pageNo,
      pageSize: rowsPerPage,
      cityId,
      operatorId,
    });
  }

  showSettlementModal = () => {
    this.setState({
      showModal: true,
    });
  };

  processingData = (data) => {
    data === "start"
      ? this.setState({ processingMsg: true })
      : this.setState({ processingMsg: false });
  };

  messageCallBack = (type, msg) => {
    const { settledDone, initiateNotification } = this.props;
    if (type) {
      if (type === MessageType.SUCCESS) {
        settledDone();
      }
      initiateNotification({
        type,
        message: msg,
      });
    }
    if (type !== MessageType.ERROR) {
      this.setState({
        showModal: false,
      });
    }
  };

  displayModal() {
    const { data, location, currentDueVehicles } = this.props;
    const {
      showModal, selected, steps, rowData,
    } = this.state;
    return (
      <SettlementModal
        data={data}
        vehicleDetails={location.state || {}}
        currentDueVehicles={currentDueVehicles}
        showModal={showModal}
        selectedVehicle={selected}
        showSettlementModal={this.showSettlementModal}
        steps={steps}
        messageCallBack={(type, msg) => {
          this.messageCallBack(type, msg);
        }}
        processingData={(d) => this.processingData(d)}
        rowData={rowData}
      />
    );
  }

  render() {
    const {
      headerLoader, content, config, totalItems, classes,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy, showModal,
    } = this.state;
    const templateString = getSettlementTemplateString(
      config,
      templateStrings.settlementLedgerList,
    );

    // const endpoint = 'settlementsPage/exportOperatorLedger';
    // let exportOperatorLedger = {
    //   addOnFilter: {
    //     cityId: this.props.cityId,
    //     operatorId: this.props.operatorId,
    //   },
    // };

    return (
      <div>
        <PageWrapper.Header
          customClass="row-header"
          heading="Dues and Settlements"
          hideS
          isHeaderFixed={false}
          removeFilterOnly
          hideDivider
        >
          <div className="dataTables_length tabWrapper" />
          <div className={classes.tableHeader}>
            <Typography
              color="inherit"
              variant="subtitle1"
              className={classes.exportBtn}
            >
              - : Amount Received
            </Typography>
            {/* <ExportButton
              query={exportOperatorLedger}
              endpoint={endpoint}
              pageName={'Settlement'}
              isDisable={this.props.refreshUpliftStatus == "Data Sync In Process"}
            /> */}
          </div>
        </PageWrapper.Header>
        {/* <PageWrapper.Body> */}
        <BarLoader scope="header" />
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="date"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateString}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
          tableContainerClassName="day-wise-dues"
          paperClassName="settlementAndDueTable"
        />
        {showModal && this.displayModal()}
        {/* </PageWrapper.Body> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Settlement
        && state.Settlement.settlementLedger
        && state.Settlement.settlementLedger.items)
      || [],
    config:
      (state
        && state.Settlement
        && state.Settlement.settlementLedger
        && state.Settlement.settlementLedger.calculationConfig)
      || {},
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    totalItems:
      (state
        && state.Settlement
        && state.Settlement.settlementLedger
        && state.Settlement.settlementLedger.totalItems)
      || 0,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchSettlementLedger: (params, loaderScope) => {
    dispatch(fetchSettlementLedgerAction(params, loaderScope));
  },
  initiateNotification: ({ type, message }) => {
    dispatch(setNotificationMessage({ type, message }));
  },
  selectedOperator: (params) => {
    dispatch(selectedOperator(params));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withRouter(DayWiseDueList)));
